
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import { API_BASE_URL, UPDATE_UNIT } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const EditUnit = ({ unitObj }) => {

    const [userDataSession, setUserDataSession] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);


    const [formData, setFormData] = useState({});
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    useEffect(() => {
        if (unitObj) {
            setFormData({
                Id: unitObj.Id,
                OrgId: userDataSession.OrgId,
                Name: `${unitObj.Name}`,
                ConversionFactor: `${unitObj.ConversionFactor}`,
                IsActive: 1,
                UpdatedBy: userDataSession.UserId,
                Code: `${unitObj.Code}`,
            });
        }
    }, [unitObj]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        let updatedFormData = { ...formData };
        updatedFormData.UpdatedBy = userDataSession.UserId;
        updatedFormData.OrgId = userDataSession.OrgId;

        console.log(updatedFormData)

        fetch(`${API_BASE_URL}${UPDATE_UNIT}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedFormData),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data, 'response');
                if (data.ResultData[0]['Status'] == 'Success') {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: `Unit edited Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error('Error updating category:', error);
            });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <div>
            {/* Edit Unit */}
            {submitBtnLoading&&(<SpinLoader/>)}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightUnitEdit"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Edit Unit</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue="Piece"
                                name="Name"
                                value={formData.Name || ''}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Code</label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue="PC"
                                name="Code"
                                value={formData.Code || ''}
                                onChange={handleInputChange}
                                maxLength={5}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Conversion Factor</label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue="PC"
                                name="ConversionFactor"
                                value={formData.ConversionFactor || ''}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="modal-footer-btn">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                 disabled={submitBtnLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-submit"
                                 disabled={submitBtnLoading}
                            >
                                {submitBtnLoading ? 'Submitting..' : 'Save Changes'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
};

EditUnit.propTypes = {
    unitObj: PropTypes.object.isRequired,
};

export default EditUnit;
